export default __webpack_public_path__ + "static/media/SAFY.f026dd44.png";